import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b19cqe097d: FaireBrandEntity = {
  token: "b_b19cqe097d",
  type: "brand",
  name: "BonBon - A Swedish Candy Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/53392e2836d547cf86875727c5b56966ec51deeb5b7a17909827402961847a1d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7f2c634e6bcb04dbd24cb88b1098b66a9f9ece979000566652328b9aff01a161.png",
  logoUrl:
    "https://cdn.faire.com/fastly/53392e2836d547cf86875727c5b56966ec51deeb5b7a17909827402961847a1d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7f2c634e6bcb04dbd24cb88b1098b66a9f9ece979000566652328b9aff01a161.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 152,
  isTopShop: true,
  isInsider: true,
  description:
    "The magical world of BonBon was founded in 2018 by friends Bobby, Leo and Selim to sweeten and revolutionize the US candy world; through a love for their homeland and its sweet and savory treats. On our journey since launching our Lower East Side retail location, community events and online efforts; we have become the bona fide destination for anyone with a sweet or savory tooth for Scandinavian treats.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:46.320Z",
    importedBy: "entity-db-cli",
  },
};
